var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47705 2.47708H4.89372L8.10788 17.4846C8.22579 18.0342 8.53161 18.5255 8.9727 18.874C9.41379 19.2225 9.96256 19.4063 10.5245 19.3937H22.342C22.8921 19.3929 23.4253 19.2044 23.8537 18.8595C24.2821 18.5145 24.58 18.0338 24.6983 17.4967L26.692 8.51875H6.18663M10.875 25.375C10.875 26.0423 10.334 26.5833 9.66663 26.5833C8.99929 26.5833 8.4583 26.0423 8.4583 25.375C8.4583 24.7077 8.99929 24.1667 9.66663 24.1667C10.334 24.1667 10.875 24.7077 10.875 25.375ZM24.1666 25.375C24.1666 26.0423 23.6256 26.5833 22.9583 26.5833C22.291 26.5833 21.75 26.0423 21.75 25.375C21.75 24.7077 22.291 24.1667 22.9583 24.1667C23.6256 24.1667 24.1666 24.7077 24.1666 25.375Z",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.2629d707fcb3ef2a7bf93fdb20760808.svg";
export { ForwardRef as ReactComponent };